export const toollist =  [
    {
        "Type": "Button",
        "Label": "Valider",
        "Color": "basic",
        "Icon": "done",
        "Method": "save"
    },
    {
        "Type": "Button",
        "Label": "Annuler",
        "Color": "warn",
        "Icon": "cancel",
        "Method": "cancel"
    }
];
